import React, {
  FC,
  useState,
  useEffect,
  useContext,
  createContext,
  useCallback,
} from "react";
import { useAuth } from "../auth/AuthContext";
import { Kiosk } from "../../../domains/kiosk/aggregates/Kiosk";
import { MeepOrderRepository } from "../../../Infrastructure/repositories/api/OrderRepository";
import { KioskRepository } from "../../../Infrastructure/repositories/api/KioskRepository";
import { getGlobalAddLog } from "Infrastructure/repositories/appInsights/AppInsights";
import { PrintType } from "domains/kiosk/aggregates/PrintType";

const addLog = getGlobalAddLog();

interface IKioskContext {
  kiosk: Kiosk | null;
}

const Context = createContext<IKioskContext>({} as IKioskContext);

//container
const kioskRepository = KioskRepository();
const orderRepository = MeepOrderRepository();

export const KioskProvider: FC = ({ children }) => {
  const { isAuth } = useAuth();

  const [kiosk, setKiosk] = useState<Kiosk | null>(null);

  useEffect(() => {
    if (kiosk && isAuth) {
      try {
        orderRepository.syncOrdersAsync(kiosk?.localId, kiosk?.id);
      } catch (error) {
        addLog && addLog("Kiosk", { error });
      }
    }
  }, [kiosk, isAuth]);

  const interceptorKiosk = useCallback((kiosk: Kiosk | null) => {
    if (
      kiosk?.localId.toUpperCase() ===
      "5650DE25-2E2A-0EAB-AC51-B5F554BC2908".toUpperCase()
    ) {
      return {
        ...kiosk,
        enableInstallment: true,
      };
    }
    if (
      kiosk?.localId.toUpperCase() ===
      "24c93427-8517-44fb-866d-d4f13662feb7".toUpperCase()
    ) {
      return {
        ...kiosk,
        enableInstallment: true,
      };
    }
    if (
      kiosk?.localId.toUpperCase() ===
      "f917eaa8-0f80-23e4-e331-f7bb45b185cc".toUpperCase()
    ) {
      return {
        ...kiosk,
        enableCpfRegister: true,
      };
    }
    if (
      kiosk?.localId.toUpperCase() ===
      "f536a9b8-e985-b340-8204-77d82f8d0ed1".toUpperCase()
    ) {
      //beco do espeto
      return {
        ...kiosk,
        oldPrinter: true,
      };
    }
    if (
      kiosk?.localId.toUpperCase() ===
      "ef4990aa-cef3-f646-0bec-2ecd30796fe6".toUpperCase()
    ) {
      //CAVALHADA DE SANTO ANTONIO
      return {
        ...kiosk,
        printType: PrintType.TICKET,
      };
    }

    if (
      kiosk?.localId.toUpperCase() ===
      "e812c55a-55f8-0a47-c4e7-d7137a1ae59d".toUpperCase() //escola deivid
    ) {
      //escola deivid
      return {
        ...kiosk,
        disableDoubleFacialValidation: true,
      };
    }

    return kiosk;
  }, []);

  useEffect(() => {
    if (isAuth) {
      kioskRepository.syncAsync().then(
        (Kiosk) => {
          setKiosk(interceptorKiosk(Kiosk));
        },
        (error) => {
          addLog && addLog("Login", { error });
        }
      );
    }
  }, [interceptorKiosk, isAuth]);

  useEffect(() => {
    kioskRepository.getAsync().then((kiosk) => {
      setKiosk(interceptorKiosk(kiosk));
    });
  }, [interceptorKiosk]);

  return <Context.Provider value={{ kiosk }}>{children}</Context.Provider>;
};

export const KioskConsumer = Context.Consumer;

export const useKiosk = () => {
  return useContext(Context);
};
